<template>
    <div class="image">
        <b-img :src="photoSrc" fluid thumbnail class="img"></b-img>
        <div v-if="!upload.src" class="control hidden">
            <b-button variant="primary" class="full" @click="uploadDialog">
                <font-awesome-icon icon="camera" class="icon" />Neues Bild
            </b-button>
            <b-button v-if="value" class="full" @click="removeImage">
                <font-awesome-icon icon="trash-alt" class="icon" />Bild löschen
            </b-button>
        </div>
        <div v-else class="control">
            <p class="label">Bild benutzen?</p>
            <b-button variant="primary" size="sm" @click="uploadImage">
                <font-awesome-icon icon="check" />
            </b-button>
            <b-button variant="secondary" size="sm" @click="dismissUpload">
                <font-awesome-icon icon="times" />
            </b-button>
        </div>
        <div v-if="upload.busy" class="processing">
            <Spinner variant="light" />
        </div>
        <input
            type="file"
            class="dialog"
            ref="uploadDialog"
            @change="onFileChanged"
        />
    </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Toaster from "@/mixins/Toaster/Toaster";
import Spinner from "@/components/Spinner/Spinner";

import "./MitgliederImage.scss";

const FilesApi = ApiFactory.get("files");

export default {
    name: "MitgliederImage",
    props: ["value"],
    mixins: [Toaster],
    components: {
        Spinner
    },
    data() {
        return {
            upload: {
                src: null,
                file: null,
                busy: false
            },
            image: null
        };
    },
    computed: {
        photoSrc() {
            if (this.upload.src) {
                return this.upload.src;
            } else {
                if (this.image) {
                    return this.image;
                } else {
                    return "https://dummyimage.com/400x400/bababa/ffffff&text=Mitgliedsbild";
                }
            }
        }
    },
    watch: {
        value: {
            handler(value) {
                this.downloadImage(value);
            },
            immediate: true
        }
    },
    methods: {
        uploadDialog() {
            this.$refs.uploadDialog.click();
        },
        onFileChanged(event) {
            const file = event.target.files[0];
            this.upload.file = file;
            this.upload.src = URL.createObjectURL(file);
        },
        async uploadImage() {
            const file = this.upload.file;
            if (file) {
                this.upload.busy = true;
                const response = await FilesApi.post(file);
                if (response.ok) {
                    // Send new ID to parent
                    const newImageId = response.json.collection[0].id;
                    this.image = null;
                    this.$emit("input", newImageId);
                    this.resetUpload();
                    this.makeToast(
                        "Bild hinzugefügt",
                        "Das Bild wurde erfolgreich hochgeladen, zum endgültigen verknüpfen müssen Sie aber noch die Änderung speichern"
                    );
                } else {
                    // Kill image
                }
                this.upload.busy = false;
            }
        },
        async downloadImage(id) {
            if (id) {
                this.upload.busy = true;
                const response = await FilesApi.getFile(id, {
                    width: 350,
                    height: 525,
                    cropped: 1,
                    quality: 90
                });
                if (response.ok) {
                    this.image = URL.createObjectURL(response.blob);
                }
                this.upload.busy = false;
            } else {
                this.image = null;
            }
        },
        removeImage() {
            this.image = null;
            this.$emit("input", null);
            this.resetUpload();
        },
        dismissUpload() {
            this.resetUpload();
        },
        resetUpload() {
            this.upload = {
                src: null,
                file: null,
                busy: false
            };
        }
    }
};
</script>
